module.exports = __webpack_public_path__ + "img/lounge_14c7304.svg";